import React from 'react';
import { getLabel } from '../../data/labels';

function Legend() {
    return (
        <div className="legenda-giocab">
            <p className="legenda-giocab__titolo">{getLabel('legend.title')}</p>
            <div className="legenda-giocab__gruppi-container">
                <div className="legenda-giocab__gruppo-legenda">
                    <span className="legenda-giocab__icona-giocab legenda-giocab__icona-giocab--1"></span>
                    <p className="legenda-giocab__descrizione-giocab">{getLabel('legend.single')}</p>
                </div>
                <div className="legenda-giocab__gruppo-legenda">
                    <span className="legenda-giocab__icona-giocab legenda-giocab__icona-giocab--2"></span>
                    <p className="legenda-giocab__descrizione-giocab">{getLabel('legend.double')}</p>
                </div>
                <div className="legenda-giocab__gruppo-legenda">
                    <span className="legenda-giocab__icona-giocab legenda-giocab__icona-giocab--3"></span>
                    <p className="legenda-giocab__descrizione-giocab">{getLabel('legend.triple')}</p>
                </div>
                <div className="legenda-giocab__gruppo-legenda">
                    <span className="legenda-giocab__icona-giocab legenda-giocab__icona-giocab--4"></span>
                    <p className="legenda-giocab__descrizione-giocab">{getLabel('legend.quadruple')}</p>
                </div>
                <div className="legenda-giocab__gruppo-legenda">
                    <span className="legenda-giocab__icona-giocab legenda-giocab__icona-giocab--5"></span>
                    <p className="legenda-giocab__descrizione-giocab">{getLabel('legend.quintuple')}</p>
                </div>
            </div>
        </div>
    )
}

export default Legend;